
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { User, ModerationEnum } from "@/types";

@Component
export default class DisplayUsers extends Vue {
  @Prop() users!: User[];

  @Prop() loading!: boolean;

  isLoading: boolean = false;

  moderationEnum = ModerationEnum;

  selected: any = [];

  pagination: any = {
    sortBy: "createdAt"
  };

  headers: any = [
    { text: "Nom", value: "fullname" },
    { text: "Username", value: "username" },
    { text: "Email", value: "email" },
    { text: "Actif ?", value: "isActive" },
    { text: "Admin ?", value: "isAdmin" },
    { text: "Vérifié ?", value: "isVerified" },
    { text: "Date de création", value: "createdAt" },
    { text: "Moderation", value: "moderation" },
    { text: "Actions", value: "action", sortable: false }
  ];

  search: String = "";

  @Watch("loading", { immediate: true })
  handleLoadingChange(value: boolean) {
    this.isLoading = value;
  }

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.users.slice();
  }

  changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }
}
